/* eslint-disable camelcase */

import { Crisp } from "crisp-sdk-web"
import posthog from "posthog-js"
import { get } from "svelte/store"
import { env } from "$env/dynamic/public"
import { browser } from "$app/environment"

import accountStore from "$lib/stores/account.js"
import profileStore from "$lib/stores/profile.js"

if (browser) {
  if (env.PUBLIC_CRISP_WEBSITE_ID) {
    Crisp.configure(env.PUBLIC_CRISP_WEBSITE_ID, { autoload: false })
  } else {
    console.warn("Crisp requires a website id but is missing in this route.")
  }
  if (env.PUBLIC_POSTHOG_PROJECT_ID) {
    // only run this if post hog is not defined
    posthog.init(
      env.PUBLIC_POSTHOG_PROJECT_ID,
      {
        api_host: "https://us.i.posthog.com",
        person_profiles: "always",
        // prevents double capture as we are doing it manually
        capture_pageview: false,
        capture_pageleave: false,
      }
    )
  } else {
    console.warn("PostHog requires a project id but is missing in this route.")
  }
}

export function identify() {
  const $account = get(accountStore)
  const $profile = get(profileStore)
  const emailAuth = $profile.auths.find((auth) => auth.type === "email")
  const fidAuth = $profile.auths.find((auth) => auth.type === "fid")

  // Setup Crisp
  Crisp.user.setNickname(`${$profile.firstName} ${$profile.lastName}`)
  Crisp.user.setCompany(`${$account.name}`, {})
  if (emailAuth) {
    Crisp.user.setEmail(emailAuth.email)
  }
  if (fidAuth) {
    Crisp.session.setData({
      user_id: $profile.userId,
      user_warpcast_fid: fidAuth.fid,
      user_warpcast_username: fidAuth.username,
    })
  }
  // if no user id use profile email
  const postHogID = $profile.userId ? `user:${$profile.userId}` : ($profile.email ?? "")
  // only call posthog if we have an id
  if (postHogID.length > 0) {
    // if no auth email use profile email
    const userEmail = emailAuth ? emailAuth.email : ($profile.email ?? "")
    // Setup PostHog
    posthog.identify(
      postHogID.toLowerCase(),
      {
        ...(userEmail ? { email: userEmail.toLowerCase() } : {}),
        ...(fidAuth ? { warpcastFid: fidAuth.fid, warpcastUsername: fidAuth.username } : {}),
      },
    )
  }
  if ($profile.userId && $profile.email) {
    // This will merge distinct_id_of_user_to_be_merged into the user sending this event
    posthog.capture(
      "$merge_dangerously",
      {
        alias: $profile.email.toLowerCase(),
      },
    )
  }
}

export function reset() {
  posthog.reset()
}

export { Crisp, posthog }
